"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _button = _interopRequireDefault(require("components/common/button"));
require("./style.scss");
var _autotimeout = _interopRequireDefault(require("components/common/autotimeout"));
var _loader = _interopRequireDefault(require("components/common/loader"));
var _conversionService = _interopRequireDefault(require("api/conversionService.js"));
var _cookies = require("../../utils/cookies");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint-disable no-console */ /* eslint-disable no-debugger */
var MytbiAgreementEpay = /*#__PURE__*/function (_React$Component) {
  function MytbiAgreementEpay(props) {
    var _this;
    _classCallCheck(this, MytbiAgreementEpay);
    _this = _callSuper(this, MytbiAgreementEpay, [props]);
    _this.state = {
      userId: '',
      loading: true,
      isBusy: false,
      token: '',
      conversionType: 'ePay'
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.linkClick = _this.linkClick.bind(_this);
    _this.getConversionEligibility = _this.getConversionEligibility.bind(_this);
    _this.setAdditionalAttribute = _this.setAdditionalAttribute.bind(_this);
    _this.onSuccessConversion = _this.onSuccessConversion.bind(_this);
    _this.onFailedConversion = _this.onFailedConversion.bind(_this);
    return _this;
  }
  _inherits(MytbiAgreementEpay, _React$Component);
  return _createClass(MytbiAgreementEpay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.analytics.track('nav', {
        page_name: 'EPay Splash Page',
        user_id: this.setAdditionalAttribute(),
        machine_id: (0, _cookies.getSessionId)(),
        is_authenticated: 'yes',
        appcd: 'conversion-app',
        pii_filter: false
      });
      this.getConversionEligibility();
    }
  }, {
    key: "getConversionEligibility",
    value: function getConversionEligibility() {
      var _this2 = this;
      var conversionType = this.state.conversionType;
      var userId = this.props.userId;
      _conversionService["default"].getEligibility(userId, conversionType).then(function (response) {
        response && response.data && response.data.ePayEligible ? _this2.setState({
          loading: false,
          token: response.data.token
        }) : window.location.replace(process.env.EXPRESSPAY_URL);
      })["catch"](function () {
        window.location.replace(process.env.EXPRESSPAY_URL);
      });
    }
  }, {
    key: "setAdditionalAttribute",
    value: function setAdditionalAttribute() {
      var userId = this.props.userId;
      var additionalAttribute = {};
      additionalAttribute.userId = userId ? userId : '';
      return additionalAttribute;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this3 = this;
      event.preventDefault();
      var token = this.state.token;
      var userId = this.props.userId;
      this.setState({
        isBusy: true
      });
      this.props.analytics.track('click', {
        event_category: 'page tag',
        event_action: 'button click',
        event_detail: 'epaysplash',
        event_label: 'agreeandcontinue',
        appcd: 'conversion-app',
        pii_filter: false
      });
      if (token === undefined || token === null || token === '') {
        this.props.history.push('/epay/error');
      } else {
        _conversionService["default"].completeConversion(userId, token).then(function (response) {
          response && response.data && response.data.conversionStatus ? _this3.onSuccessConversion(response) : _this3.onFailedConversion();
        })["catch"](function () {
          window.location.replace(process.env.EXPRESSPAY_URL);
        });
      }
    }
  }, {
    key: "onSuccessConversion",
    value: function onSuccessConversion(response) {
      window.location.replace(response.data.url);
      this.props.analytics.track('click', {
        event_category: 'system tag',
        event_action: 'system verified',
        event_detail: 'sucess',
        event_label: 'conversionresult',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "onFailedConversion",
    value: function onFailedConversion() {
      this.props.history.push('/epay/error');
      this.props.analytics.track('click', {
        event_category: 'system tag',
        event_action: 'system verified',
        event_detail: 'error',
        event_label: 'conversionresult',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "linkClick",
    value: function linkClick(event) {
      this.props.analytics.track('click', {
        event_category: 'page tag',
        event_action: 'link click',
        event_detail: event.target.id,
        event_label: 'termsandconditionlink',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(_loader["default"], null);
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "align-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tds-h1--article tds-h1--large center-align-text margin-top-xx-large margin-bot-xx-large"
        }, "ePay is now MyTravelers for Business."), /*#__PURE__*/React.createElement("div", {
          className: "disclaimer"
        }, /*#__PURE__*/React.createElement("div", {
          className: "splashScreenImageGroup margin-bottom"
        }, /*#__PURE__*/React.createElement("img", {
          className: "splashImage",
          src: "../../images/ePayConversionSplashScreen.png",
          alt: "MyTravelers Home Page"
        }), /*#__PURE__*/React.createElement("div", {
          className: "tds-medium splashText margin-bottom"
        }, "All your policies, billing and claims in one place.")), /*#__PURE__*/React.createElement("p", {
          className: "tds-small align-left"
        }, "By selecting Agree & Continue below, you certify that you are a Travelers policyholder or an administrator for the policyholder and you have read and agree to the following ", /*#__PURE__*/React.createElement("a", {
          onClick: this.linkClick,
          id: "TERMSOFSERVICE",
          href: process.env.TRAVELERS_LEGAL_URL,
          target: "_blank"
        }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
          onClick: this.linkClick,
          id: "PREMIUMAUDITELECTRONICUSAGEAGREEMENT",
          href: process.env.TRAVELERS_PREMIUMAUDIT_URL,
          target: "_blank"
        }, "Premium Audit Electronic Usage Agreement"), "."), /*#__PURE__*/React.createElement("p", {
          className: "tds-small align-left"
        }, "We use cookies to make your experience of this site better and to distinguish you from other users. By continuing to use our website, you are agreeing to our use of cookies. For more information on using and disabling cookies, please read our ", /*#__PURE__*/React.createElement("a", {
          onClick: this.linkClick,
          id: "ONLINEPRIVACYSTATEMENT",
          href: process.env.ONLINE_PRIVACY_STATEMENT,
          target: "_blank"
        }, "Online Privacy Statement"), "."), /*#__PURE__*/React.createElement("div", {
          className: "tds-field margin-top-xx-large"
        }, /*#__PURE__*/React.createElement("form", {
          onSubmit: this.onSubmit
        }, /*#__PURE__*/React.createElement(_button["default"], {
          type: "submit",
          text: "Agree & Continue",
          isBusy: this.state.isBusy,
          onClick: this.onSubmit,
          style: "tds-button--primary buttonwidth"
        })))), /*#__PURE__*/React.createElement("hr", {
          className: "tds-field content-divider margin-top-xx-large disclaimer"
        }), /*#__PURE__*/React.createElement("div", {
          className: "prefooter"
        }, /*#__PURE__*/React.createElement("p", {
          className: "tds-medium no-margin"
        }, "If you require any assistance, call us for help."), /*#__PURE__*/React.createElement("span", {
          className: "tds-medium call-us"
        }, /*#__PURE__*/React.createElement("a", {
          onClick: this.linkClick,
          id: "PHONENUMBER",
          href: 'tel:+' + process.env.CALL_US_NUM
        }, process.env.CALL_US_NUM)), /*#__PURE__*/React.createElement("span", {
          className: "tds-medium"
        }, "8 AM to 8 PM ET, Monday-Friday")));
      }
    }
  }]);
}(React.Component);
var TimeoutMytbiAgreement = (0, _autotimeout["default"])(MytbiAgreementEpay);
var _default = exports["default"] = TimeoutMytbiAgreement;